import EventEmitter from 'wolfy87-eventemitter';
import { inject, injectable } from 'inversify';
import { isMobile } from '../../../helpers/device';
import type { IStateController, IStateEvents } from './state.interface';
import { STATE_MODULE_IDS } from './state.types';

@injectable()
export class StateController extends EventEmitter implements IStateController {
  state = {
    isLocked: false,
    isDragging: false,
    isZooming: false,
    isLoading: true,
    schemeIsLoaded: false,
    ticketsIsLoaded: false,
    isFailure: false,
    isFullscreen: false,
    isMinimapMoving: false,
    showMobileOverlay: isMobile(),
  };

  constructor(@inject(STATE_MODULE_IDS.STATE_EVENTS) public events: IStateEvents) {
    super();

    this.addListener(this.events.DATA_LOADED, () => {
      this.state.isLoading = false;
    });

    this.addListener(this.events.SHCEME_DATA_LOADED, () => {
      this.state.schemeIsLoaded = true;
    });

    this.addListener(this.events.TICKETS_DATA_LOADED, () => {
      this.state.ticketsIsLoaded = true;
    });

    this.setState = this.setState.bind(this);
  }

  get isDragging() {
    return this.state.isDragging;
  }

  get isLoading() {
    return this.state.isLoading;
  }

  get schemeIsLoaded() {
    return this.state.schemeIsLoaded;
  }

  get ticketsIsLoaded() {
    return this.state.ticketsIsLoaded;
  }

  get isZooming() {
    return this.state.isZooming;
  }

  get isFullscreen() {
    return this.state.isFullscreen;
  }

  // TODO use for zooming
  get isLocked() {
    return this.state.isLocked;
  }

  setState(newState = {}, withoutEmit = false) {
    this.state = {
      ...this.state,
      ...newState,
    };

    if (this.state.isFailure) {
      this.state.isLoading = false;
    }

    if (!withoutEmit) {
      this.emit(this.events.UPDATE, this.state);
    }
  }

  lock() {
    this.state.isLocked = true;
  }

  unlock() {
    this.state.isLocked = false;
  }
}
